export async function fetchHotPosts(limit?: number): Promise<Post.Info[]> {
  return http
    .get<Post.Info[]>('/v1/leaderboards/hot')
    .then((res) => {
      try {
        if (limit) {
          return res.data.slice(0, limit)
        } else {
          return res.data
        }
      } catch (error) {
        return []
      }
    })
    .catch(() => [] as Post.Info[])
}
